import React from "react";

import logger from "../../utils/LoggerFrontend";
import { channels } from "../../data/app__channels";

class CampaignModalPreview extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedChannel: props.selectedChannel
    };
  }

  onChangeSelected(newSelectedChannel) {
    if (newSelectedChannel == this.state.selectedChannel) {
      return;
    }

    this.setState({
      selectedChannel: newSelectedChannel
    });
  }

  render() {
    logger.debug("CampaignModalPreview:render", "called...", this.state.selectedChannel);
    const selectedChannel = this.state.selectedChannel;

    return (
      <div className="channel__preview-wrapper-backdrop">
        <div className="channel__preview-wrapper fade-in">
          <div className="channel__preview-wrapper-content">
            <div className="channel__preview-wrapper-content-channels">
              {channels.map((channel) => (
                <div
                  className={`${selectedChannel == channel.channel_short_name ? "selected" : ""}`}
                  onClick={this.onChangeSelected.bind(this, channel.channel_short_name)}
                  key={channel.channel_short_name}
                >
                  {channel.channel_full_name}
                </div>
              ))}
            </div>

            <div className="channel__preview-wrapper-content-previews">
              {selectedChannel && (
                <img
                  className="channel__preview-wrapper-img"
                  src={`/images/examples-channels/${selectedChannel}-preview.png`}
                  alt=""
                />
              )}
            </div>
          </div>
          <br />
        </div>
      </div>
    );
  }
}

export default CampaignModalPreview;
